// extracted by mini-css-extract-plugin
export default {"tooltip":"ExportIndex_tooltip__1uK4G","icon":"ExportIndex_icon__Dvm91"};